export default[
    {
        show(row,extra){
            return(
               row.shbj==='1'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '已提交待内部审核';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='4'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '监督待审核';
        }
    },{
        show(row,extra){
            return(
               row.shbj==='8'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '待平台审核';
        }
    },{
        show(row,extra){
            return(
               row.shbj==='0'
            )
        },
        tag:'my-tag',
        type:'warning',
        text(row){
            return '未提交';
        }
    },{
        show(row,extra){
            return(
               row.shbj==='9'
            )
        },
        tag:'my-tag',
        type:'success',
        text(row){
            return '已发布';
        }
    },{
        show(row,extra){
            return(
               row.shbj==='3'
            )
        },
        tag:'my-tag',
        type:'danger',
        text(row){
            return '退回：'+row.by2;
        }
    }
]